import { defineComponent, h } from 'vue';
import { Line } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale } from 'chart.js';

// Register necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, LineElement, Title, Tooltip, Legend);

export default defineComponent({
  name: 'LineChartComponent',
  components: {
    Line
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
            padding: 25,
            labels: {
              font: {
                // Add font options here if needed
              }
            }
          },
          // Disable datalabels plugin for this chart
          datalabels: {
            display: false
          },
          tooltip: {

          }
        },
        scales: {
          y: {
            position: 'left',
            grid: {
              display: true,
              color: "#e4e6e8",
            },
            ticks: {
              maxTicksLimit: 10,
              font: {
                size: 10
              },
            }
          },
          y1: {
            display: true,
            position: 'right',
            min: 0,
            max: 100,
            grid: {
              drawOnChartArea: false // Only want the grid lines for one axis
            }
          },
          x: {
            grid: {
              display: false
            },
            ticks: {
              maxTicksLimit: 8,
              font: {
                size: 10
              },
              maxRotation: 0,
              minRotation: 0,
            },
          }
        }
      }
    };
  },
  render() {
    return h('div', { style: { height: '500px' } }, [
      h(Line, {
        data: this.chartData,
        options: this.options
      })
    ]);
  }
});
